// TODO write tests
/** Like Lodash's groupBy, but also preserves order of group keys -- Lodash's groupBy cannot
 * preserve order of keys if there are integer-like strings in the keys, because JavaScript
 * does not maintain insertion order for integer-like strings.
 *
 * Returns a Map() instead of an object, to ensure insertion order is preserved.
 */
export function groupByWithPreservedOrder(array, iteratee) {
    const grouped = new Map();
    for (const value of array) {
        const key = iteratee(value);
        if (!grouped.has(key)) {
            grouped.set(key, []);
        }
        grouped.get(key).push(value);
    }
    return grouped;
}
//# sourceMappingURL=groupByWithPreservedOrder.js.map